import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PlayersService } from 'src/app/services/players.service';
import { environment } from 'src/environments/environment';
import { IonSearchbar } from '@ionic/angular';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss'],
})
export class PlayerComponent implements OnInit {

  @Input() currentStepObservable: BehaviorSubject<string>;
  @Input() playerIndex: number;

  @Output() goBack: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() playerSelected: EventEmitter<any> = new EventEmitter<any>(false);

  players: Array<any> = null;
  searchInProgress = false;

  @ViewChild('searchPlayer') searchPlayerInput: IonSearchbar;

  constructor(private playersService: PlayersService) { }

  ngOnInit() {
    this.currentStepObservable.subscribe((step) => {
      if (step === 'player') {
        this.autoFocusSearchInput();
      }
    });
  }

  ngAfterViewInit() {
    this.autoFocusSearchInput()
    }

  async search(event) {
    if (!!event.detail.value === false || event.detail.value.length < environment.minPlayerSearchCharacters) {
      return;
    }
    const query = event.detail.value;

    this.searchInProgress = true;
    this.players = await this.playersService.getByQueryLocal(query);

    this.searchInProgress = false;
  }

  select(event) {
    this.playerSelected.emit(event);
    this.goBack.emit(true);
  }

  autoFocusSearchInput() {
    const t = setTimeout(() => {
      this.searchPlayerInput.setFocus()
      clearTimeout(t);
    }, 100);
  }
}
